import { useMemo } from 'react';
import { Check, Edit } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { DataGridProps, GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { CustomerFragmentFragment } from '../../../../api/gql';
import { renderCellOrDefault } from '../../../../components/table/renderCellOrDefault';
import { Table } from '../../../../components/table/Table';
import { getRemindingToneTransKey } from '../../../../utils/invoice';

type Props = {
  customers?: CustomerFragmentFragment[];
  onCustomerChoose: (customer: CustomerFragmentFragment) => void;
} & Partial<DataGridProps>;

export const CustomersTable = ({ customers, onCustomerChoose, ...props }: Props) => {
  const { t } = useTranslation();
  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'name',
        headerName: t('name') as string,
        flex: 1,
        minWidth: 200,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'vatId',
        headerName: t('vatId') as string,
        flex: 1,
        minWidth: 100,
        maxWidth: 130,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'taxId',
        headerName: t('taxId') as string,
        flex: 1,
        minWidth: 100,
        maxWidth: 130,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'phoneNumber',
        headerName: t('phone') as string,
        flex: 1,
        minWidth: 100,
        maxWidth: 130,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'email',
        headerName: t('email') as string,
        flex: 1,
        minWidth: 150,
        maxWidth: 200,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'address',
        headerName: t('address') as string,
        flex: 1,
        minWidth: 150,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'remindingTone',
        headerName: t('remindingTone.title') as string,
        flex: 1,
        minWidth: 100,
        maxWidth: 150,
        valueGetter: (params) => {
          return t(getRemindingToneTransKey(params.row.remindingTone));
        },
      },
      {
        field: 'action',
        headerName: '',
        minWidth: 150,
        maxWidth: 150,
        flex: 1,
        align: 'right',
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <Box display={'flex'} gap={1}>
            <Button startIcon={<Check />} variant={'contained'} onClick={() => onCustomerChoose(params.row)}>
              Vybrat
            </Button>
          </Box>
        ),
      },
    ],
    [onCustomerChoose, t],
  );

  return <Table id={'customers'} autoHeight {...props} columns={columns} rows={customers ?? []} />;
};
